// extracted by mini-css-extract-plugin
export default {"title":"style_title__fTeBp","tabHeader":"style_tabHeader__obc1B","note":"style_note__wm0gM","append":"style_append__KgQyY"};